import React from "react";
import {
  Flex,
  Text,
  Box,
  Image,
  Spacer,
  Avatar,
  Menu,
  Button,
  ButtonGroup,
  MenuList,
  MenuItem,
  MenuButton,
  useToast,
  Heading,
  useDisclosure,
  IconButton,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  DrawerOverlay,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ChevronDownIcon, HamburgerIcon } from "@chakra-ui/icons";
// import axios from 'axios';
import { useSelector } from "react-redux";
import img10 from "../images/AiM4u Registered Logo (1).png";
//import { Hidden } from "@mui/material";

const Navbar = ({ isAdmin }) => {
  const toast = useToast();
  const { userId } = useSelector((state) => {
    return state.user;
  });
  const { isAuthenticated } = useSelector((state) => {
    return state.user;
  });

  const { isOpen, onOpen, onClose } = useDisclosure();

  const linkStyles = {
    p: ["2", "2", "2", "3"],
    mx: ["0", "0", "3", "3"],
    fontSize: ["xl", "xl", "2xl", "2xl"],
    color: "white",

    _hover: {
      color: "white",
      textDecoration: "underline",
    },
  };

  const LoginRegister = ({ isAuthenticated, isAdmin }) => (
    <>
      {isAuthenticated && (
        <Flex
          direction={["column", "column", "row", "row"]}
          align={["center", "center", "center", "center"]}
        >
          <Flex
            direction={"row"}
            p={["2", "2", "2", "3"]}
            my={["3", "3", "auto", "auto"]}
            fontSize={["xl", "xl", "2xl", "2xl"]}
            color="#000080"
          >
            <Avatar bg="#000080" mb="2" ml="8" mr="3" />
            <Menu >
              <MenuButton
                as={Button}
                color={"#000080"}
                marginTop={"4%"}
                fontSize={["md", "md", "lg", "lg"]}
                backgroundColor={"transparent"}
                rightIcon={<ChevronDownIcon />}
                border={"1px"}
                _hover={{ color: "#000080" }}
              >
                Profile
              </MenuButton>

              <MenuList color={"#000080"}>
                {!isAdmin && (
                  <Link to="/profile">
                    <MenuItem>Update Profile</MenuItem>
                  </Link>
                )}
                {isAdmin && (
                  <Link to="/admin">
                    <MenuItem>Admin Interface</MenuItem>
                  </Link>
                )}
                {!isAdmin && (
                  <Link to={"/applied"}>
                    <MenuItem>My Dashboard</MenuItem>
                  </Link>
                )}
                <Link to={"/changePassword"}>
                  <MenuItem>Change Password</MenuItem>
                </Link>
                <MenuItem
                  onClick={() => {
                    window.sessionStorage.removeItem("accessToken");
                    window.location.href = "/login";
                  }}
                >
                  Logout
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
      )}

      {!isAuthenticated && (
        <Box bg="white" pl={0} alignSelf={"center"}>
          <Flex as="nav">
            <ButtonGroup pr="2vw" pt="0.5vw" spacing={4} alignSelf={"center"}>
              <Link to="/login">
                <Button
                  size={{ base: "sm", md: "sm", lg: "md" }}
                  bg={"#000080"}
                  textColor={"white"}
                >
                  Login
                </Button>
              </Link>
              <Link to="/register">
                <Button
                  size={{ base: "sm", md: "sm", lg: "md" }}
                  borderColor={"#000080"}
                  variant={"outline"}
                  textColor={"#008000"}
                >
                  Register
                </Button>
              </Link>
            </ButtonGroup>
          </Flex>
        </Box>
      )}
    </>
  );

 
  const showDesktopMenu = useBreakpointValue({ base: false, md: true });

  return (
    <Flex
      w="100%"
      h="80px"
      direction={["column", "column", "row", "row"]}
      whiteSpace="nowrap"
      flexWrap="wrap"
      backgroundColor="white"
      position="sticky"
      top="0"
      zIndex="80"
      boxShadow="md"
    >
      <Flex alignItems="center" gap={0}>
        <Link to="https://aim4u.co.in/#/">
          <Image src={img10} w="5.5rem" title="AiM4u Registered Logo" />
        </Link>
        <Heading
          fontFamily="SF Pro Display, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
          color="#000080"
          fontSize="4xl"
          fontWeight="bold"
        >
          Gyan
        </Heading>
      </Flex>
      <Spacer />

      {/* Desktop Menu */}
      {showDesktopMenu && (
        <Stack direction="row" display="flex" align="center">
          <Flex align="center" direction="row">
            {[
              { to: "/", label: "Home" },
              { to: "/about", label: "About" },
              { to: "/internship", label: "Internships" },
              { to: "/faq", label: "FAQs" },
            ].map((item) => (
              <Box key={item.to} px={4}>
                <Link to={item.to} className="nav-link">
                  <Box
                    px={3}
                    py={1}
                    borderRadius="md"
                    transition="all 0.3s ease-in-out"
                    _hover={{
                      bg: "rgba(0, 128, 0, 0.2)",
                      color: "#000080",
                      textShadow: "none",
                      transform: "scale(1.05)",
                    }}
                  >
                    <Text
                      color={"#000080"}
                      fontSize="xl"
                      fontWeight="bold"
                      transition="all 0.3s ease-in-out"
                    >
                      {item.label}
                    </Text>
                  </Box>
                </Link>
              </Box>
            ))}
          </Flex>
          <LoginRegister isAuthenticated={isAuthenticated} isAdmin={isAdmin} />
        </Stack>
      )}

      {/* Mobile Menu */}
      <IconButton
        aria-label="Open Menu"
        size="sm"
        mr={2}
        icon={<HamburgerIcon />}
        display={["flex", "flex", "none", "none"]}
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent
          maxW="250px"
          bg="rgba(255, 255, 255, 0.9)" // Semi-transparent
          backdropFilter="blur(8px)"
        >
          {/* Custom Close (X) Icon */}
          <Flex justify="flex-end" p={2}>
            <IconButton
              aria-label="Close menu"
              icon={<Box as="span" fontSize="2xl">&times;</Box>} // X symbol
              variant="ghost"
              onClick={onClose}
            />
          </Flex>

          <DrawerHeader
            fontSize="2xl"
            fontWeight="bold"
            color="#1e3a8a"
            textAlign="left"
            mt="-2"
          >
            Gyan
          </DrawerHeader>

          <DrawerBody>
            {/* Menu items left-aligned */}
            <Stack spacing={4} mt={3}>
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/internship", label: "Internships" },
                { to: "/faq", label: "FAQs" },
              ].map((item) => (
                <Link key={item.to} to={item.to} className="nav-link">
                  <Box
                    px={4}
                    py={2}
                    borderRadius="md"
                    transition="all 0.3s ease-in-out"
                    textAlign="left"
                    _hover={{
                      bg: "rgba(0, 255, 0, 0.3)",
                      transform: "scale(1.05)",
                    }}
                  >
                    <Text color={"#000080"} fontSize="lg" fontWeight="bold">
                      {item.label}
                    </Text>
                  </Box>
                </Link>
              ))}
            </Stack>

            <Box mt={4}>
              <LoginRegister isAuthenticated={isAuthenticated} isAdmin={isAdmin} />
            </Box>
          </DrawerBody>
        </DrawerContent>

      </Drawer>
    </Flex>
  );
};

export default Navbar;